import * as React from "react";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import StarBorderPurple500Icon from "@mui/icons-material/StarBorderPurple500";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import EnergySavingsLeafIcon from '@mui/icons-material/EnergySavingsLeaf';
import InsertChartOutlinedIcon from "@mui/icons-material/InsertChartOutlined";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import "./index.css";
import { toast } from "react-toastify";
import Form from "../ScenarioDetails/Form";
import ListItem from "../ScenarioDetails/ListItem";
import HTMLRenderer from "../../../components/HtmlRendering";
import NetworkGraph from "../../../components/NetworkGraph";
import WinningWall from "../../../components/winningWall/WinningWall";
import BreadCrumbs from "../../../components/navbar/BreadCrumb";
import LoaderImg from "../../../components/ui/loader";
import "react-toastify/dist/ReactToastify.css";
import {
  getWinningWallDataCorporate,
  scenarioDetailsVersion2,
  scenarioStartGameVersion2,
} from "../../../APIConfig/version2Scenario";
import jwtDecode from "jwt-decode";
import { useSelector } from "react-redux";
import {
  Backdrop,
  Box,
  Button,
  Chip,
  Divider,
  Stack,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { topologyCorporateDetails } from "../../../APIConfig/scenarioConfig";
import { allCorporateList, getCorporateDetail } from "../../../APIConfig/NewCorporateApiConfig";

const ScenarioDetailsVersion2 = () => {
  const [tabValue, setTabValue] = useState(0);
  const [value, setValue] = React.useState("1");
  const [topology, setTopology] = React.useState({});
  const [isActive, setIsActive] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [diagram, setDiagram] = React.useState(false);
  const [mail, setMail] = React.useState([]);
  const [inputValue, setInputValue] = React.useState("");
  const [DTvalue, setDTvalue] = React.useState(new Date());
  const [data, setData] = React.useState([]);
  const [winningWallData, setWinningWallData] = useState([]);
  const [scenarioMail, setScenarioMail] = React.useState([]);
  const [machine, setMachine] = React.useState([]);
  const [hide, setHide] = React.useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  const currentPath = location?.pathname;
  const token = localStorage.getItem("access_token");
  let user = {};
  try {
    if (token) user = jwtDecode(token);
  } catch (_) { }






  // walthrough data new
  const [newtabValue, setNewTabValue] = useState(0);
  const walkthrough = Array.isArray(data?.walkthrough_files)
    ? data.walkthrough_files
    : [];
  const teams = [...new Set(walkthrough.map(i => i.team_name))];
  const selectedTeam = teams[newtabValue] || "";
  const files = walkthrough.filter(
    i => i.team_name === selectedTeam
  );




  // Split the URL by slashes and get the last element
  const parts = currentPath.split("/");
  const lastValue = parts[parts.length - 1];





  React.useEffect(() => {
    const getApi = async () => {
      if (!lastValue) return;
      setIsActive(true);
      try {
        const response = await getCorporateDetail(lastValue);
        if (response?.data) {
          setData(response.data);
          setTopology(response?.data?.infrastructure)
        }
      } catch (error) {
        if (error?.response?.status === 404) {
          navigate("/corporate/category", { replace: true });
        }
      } finally {
        setIsActive(false);
      }
    };
    getApi();
  }, [lastValue, navigate]);






  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };





  const scenariosData = [
    {
      id: data?.id,
      // category: data?.category_name,
      category: data?.category?.name,
      points: data?.points,

      // time: data?.scenario_time,
      time: data?.created_at,
      severity: data?.severity,
      img: data?.thumbnail_url,
      scenarioName: data?.name,
      description: data?.description,
      cpu:
        data?.scenario_hardware_details?.vcpu || data?.hardware_details?.vcpu,
      hdSpace:
        data?.scenario_hardware_details?.disk_size ||
        data?.hardware_details?.disk_size,
      ram: data?.scenario_hardware_details?.RAM || data?.hardware_details?.RAM,
      objectives: data?.objective,
      tool_technology: data?.objective,
      prerequisites: data?.prerequisite,
      machine:
        data?.scenario_hardware_details?.vm_count ||
        data?.hardware_details?.vm_count,
      type: data?.type,
      ttx_enabled: data?.ttx_enabled,
      scenario_documents: data?.walkthrough_files,
      type: data?.type?.name
    },
  ];

  const breadcrumbs = [
    { name: "Dashboard", link: "/" },
    {
      name: "Category",
      link: "/corporate/category",
    },
    { name: "Detail Page", link: `${location.pathname}` },
  ];

  const handleTabChangeForPDF = (newValue) => {
    setTabValue(newValue);
    console.error(newValue);
  };

  const capitalizeTeamName = (team) => {
    return team.replace(/_/g, " ");
  };

  // const teams = Object.keys(data?.files_data || {}).filter(
  //   (team) => data?.files_data[team]?.length > 0
  // );
  // const selectedTeam = teams[tabValue] || "";
  // const files = data?.files_data?.[selectedTeam] || [];


  return (
    <Stack>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isActive}
      >
        <LoaderImg />
      </Backdrop>
      <BreadCrumbs breadcrumbs={breadcrumbs} />
      <Stack spacing={2} display="flex" width="100%" justifyContent="center">
        {/* container */}
        <Stack
          sx={{ justifyContent: "center", width: "100%", alignItems: "center" }}
        >
          {/* box */}
          <Stack width="90%" justifyContent="center" gap={2}>
            {/* Heading */}
            <Stack direction="row" justifyContent="space-between">
              <Typography variant="h1" fontSize="40px">
                Corporate
              </Typography>
            </Stack>
            {/* scenario Details */}
            <Stack>
              <Box>
                {scenariosData?.map((data, index) => {
                  return (
                    <Stack
                      key={index}
                      sx={{
                        backgroundColor: "background.secondary",
                        //   border: "1px solid #12464C",
                        marginTop: 2,
                        borderRadius: "8px",
                      }}
                    >
                      <Stack direction="row" gap={4} p={3}>
                        <img
                          src={data.img}
                          width="160px"
                          height="211px"
                          alt="no img"
                          style={{ borderRadius: "16px" }}
                        />
                        <Stack sx={{ display: "flex", width: "100%", }}>
                          <Stack
                            mb={1}
                            direction="row"
                            justifyContent="space-between"
                          >
                            <Chip
                              label={data.category}
                              sx={{
                                width: "10%",
                                minWidth: "250px",
                                backgroundColor: "#393939",
                                height: "30px",
                              }}
                            />

                          </Stack>


                          <Stack direction="row" gap={2} alignItems="center" >
                            <Typography variant="body1" className="cardPoints">
                              <StarBorderPurple500Icon sx={{ mb: -0.5 }} />
                              {data?.points} Points
                            </Typography>
                            {/* <Typography variant="body1" className="cardPoints">
                              <TimerOutlinedIcon sx={{ mb: -0.5 }} />
                              {data.time} hour
                            </Typography> */}
                            <Typography variant="body1" className="cardPoints">
                              <InsertChartOutlinedIcon sx={{ mb: -0.5 }} />
                              {data?.severity}
                            </Typography>

                            {data?.type?.name && (
                              <Typography
                                variant="body1"
                                className="cardPoints"
                              >
                                <WorkspacePremiumOutlinedIcon
                                  sx={{ mb: -0.5, }}
                                />
                                {data?.type?.name}
                              </Typography>
                            )}

                            {data?.ttx_enabled &&
                              <Typography variant="body1" className="cardPoints">
                                <EnergySavingsLeafIcon
                                  sx={{ mb: -0.5, }}
                                />
                                TTX enabled
                              </Typography>}



                          </Stack>
                          <Stack mb={2}>
                            <Typography variant="h1">
                              {data?.scenarioName}
                            </Typography>
                            {hide ? (
                              <Stack sx={{ width: "100%", wordBreak: 'break-word' }}>
                                <Typography>
                                  {data?.description
                                    ?.replace(/(<([^>]+)>)/gi, "")
                                    .substring(0, 250)}
                                </Typography>
                                <Typography
                                  style={{
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                    color: "#00ffff",
                                    width: "fit-content",
                                  }}
                                  onClick={() => setHide(!hide)}
                                >
                                  Read more
                                </Typography>
                              </Stack>
                            ) : (
                              <Stack sx={{ width: "100%" }}>
                                <HTMLRenderer htmlContent={data?.description} />
                                <Typography
                                  style={{
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                    color: "#00ffff",
                                    width: "fit-content",
                                  }}
                                  onClick={() => setHide(!hide)}
                                >
                                  Read less
                                </Typography>
                              </Stack>
                            )}
                          </Stack>
                          {/* mapping diagram */}
                          <Stack direction="row" sx={{ my: 2, gap: 3 }}>

                            <Button
                              startIcon={<AccountTreeIcon />}
                              variant="contained"
                              sx={{ height: "50px" }}
                              size="large"
                              onClick={() => setDiagram(!diagram)}
                            >
                              Network Topology
                            </Button>
                          </Stack>
                          <Stack
                            style={{
                              display: diagram ? "block" : "none",
                              justifyContent: "center",
                              alignItems: "center",
                              width: "100%",
                              position: "relative",
                            }}
                          >
                            <NetworkGraph
                              id={data?.id}
                              topology={topology}
                              setDiagram={setDiagram}
                              diagram={diagram}
                            />
                          </Stack>


                          {/* scenario config. */}
                          {/* <Stack
                            direction="row"
                            // justifyContent="space-between"
                            // width="20%"
                            alignItems="start"
                            width="100%"
                            gap={5}
                            border={'1px solid white'}

                          >
                            <Stack
                              alignItems="center"
                            // border={"1px solid white"}
                            >
                              <Typography
                                variant="body2"
                                // className="configuration"
                                style={{ color: "#00ffff" }}
                              >
                                CPU
                              </Typography>
                              <Typography variant="body1">
                                {data.cpu}
                              </Typography>
                            </Stack>
                            <Stack alignItems="center">
                              <Typography
                                variant="body2"
                                // className="configuration"
                                style={{ color: "#00ffff" }}
                              >
                                HD Space
                              </Typography>
                              <Typography variant="body1">
                                {data.hdSpace}
                              </Typography>
                            </Stack>
                            <Stack alignItems="center">
                              <Typography
                                variant="body2"
                                // className="configuration"
                                style={{ color: "#00ffff" }}
                              >
                                RAM
                              </Typography>
                              <Typography variant="body1">
                                {data.ram}
                              </Typography>
                            </Stack>
                            <Stack alignItems="center">
                              <Typography
                                variant="body2"
                                // className="configuration"
                                style={{ color: "#00ffff" }}
                              >
                                Machine
                              </Typography>
                              <Typography variant="body1">
                                {data.machine}
                              </Typography>
                            </Stack>
                          </Stack> */}


                        </Stack>
                        {/* network diagram */}
                      </Stack>
                    </Stack>
                  );
                })}
              </Box>
            </Stack>

            <Stack direction="row" gap={1}>


              {/* scenario tabs details and practices details */}
              <Stack direction="row" gap={2} minWidth="50%" >
                <Stack
                  sx={{
                    backgroundColor: "background.secondary",
                    p: 2,
                    borderRadius: "16px",
                    minWidth: "50%",
                  }}
                >
                  <TabContext value={value}>
                    <Box>
                      <TabList
                        onChange={handleTabChange}
                        textColor="#ffffff"
                        TabIndicatorProps={{
                          sx: { backgroundColor: "#b46228" },
                        }}
                      >
                        {/* <Tab label="Objectives" value="" /> */}
                        <Tab label="objective" value="1" />
                        <Tab label="prerequisite" value="2" />
                      </TabList>
                    </Box>

                    <TabPanel
                    //  value="1"
                    >
                      <Stack
                        style={{
                          backgroundColor: "custom.main",
                          borderRadius: "16px",
                          justifyContent: "space-around",
                          alignItems: "space-around",
                          gap: 54,
                        }}
                      >
                        <Stack>{data.scenario_objectives}</Stack>

                        <Stack gap={2}>
                          {data?.document_urls?.map((item, index) => {
                            return (
                              <Button
                                key={index}
                                variant="outlined"
                                color="secondary"
                                onClick={() => window.open(item, "_blank")}
                              >
                                VIEW DOCUMENT
                              </Button>
                            );
                          })}
                        </Stack>
                      </Stack>
                    </TabPanel>

                    <TabPanel value="1">
                      <Stack
                        sx={{
                          backgroundColor: "custom.main",
                          borderRadius: "16px",
                          height: "500px",
                          overflow: "scroll",
                          px: 4,
                        }}
                      >
                        <HTMLRenderer htmlContent={data?.objective} />
                      </Stack>
                    </TabPanel>
                    <TabPanel value="2">
                      <Stack
                        sx={{
                          backgroundColor: "custom.main",
                          borderRadius: "16px",
                          height: "500px",
                          overflow: "scroll",
                          px: 4,
                        }}
                      >
                        <HTMLRenderer htmlContent={data?.prerequisite} />
                      </Stack>
                    </TabPanel>
                  </TabContext>
                </Stack>



                {/* walkthrough section details */}
                {/* <Stack
                  sx={{
                    backgroundColor: "background.secondary",
                    p: 2,
                    borderRadius: "16px",
                    // width: data?.scenario_documents && "50%",
                    // display: !data?.scenario_documents && "none",
                    width: data?.walkthrough_files && "50%",
                    display: !data?.walkthrough_files && "none",
                  }}
                >
                  
                  <Practice item={data?.walkthrough_files} />
                </Stack> */}
              </Stack>





              {/* walkthrough section details new */}
              {
                data?.walkthrough_files?.length > 0
                && (
                  // <Stack
                  //   sx={{
                  //     backgroundColor: "background.secondary",
                  //     p: 3,
                  //     borderRadius: 1.5,
                  //     minWidth: "50%",
                  //   }}
                  // >
                  //   <Typography variant="h2">Walkthroughs</Typography>
                  //   <Stack>
                  //     <Tabs
                  //       value={tabValue}
                  //       textColor="secondary"
                  //       indicatorColor="secondary"
                  //       onChange={(event, newValue) =>
                  //         handleTabChangeForPDF(newValue)
                  //       }
                  //     >
                  //       {teams.map(
                  //         (team, index) =>
                  //           data?.files_data[team].length > 0 && (
                  //             <Tab
                  //               key={index}
                  //               label={capitalizeTeamName(team)}
                  //               sx={{
                  //                 fontSize: "18px",
                  //                 fontWeight: "500",
                  //                 color: "#EAEAEB",
                  //                 textTransform: "capitalize",
                  //               }}
                  //             />
                  //           )
                  //       )}
                  //     </Tabs>

                  //     <Divider sx={{ border: "1px solid rgba(83, 86, 96, 1)" }} />

                  //     <Stack
                  //       direction="row"
                  //       justifyContent="start"
                  //       alignItems="center"
                  //       pt={2.5}
                  //       spacing={3}
                  //     >
                  //       {files.map((file, index) => (
                  //         <Stack
                  //           key={index}
                  //           direction="column"
                  //           justifyContent="center"
                  //           alignItems="center"
                  //           spacing={1}
                  //           sx={{
                  //             width: "90px",
                  //             height: "112px",
                  //             borderRadius: "12px",
                  //             padding: "12px 8px",
                  //             backgroundColor: "rgba(145, 158, 171, 0.12)",
                  //             cursor: "pointer",
                  //           }}
                  //           onClick={() => window.open(file, "_blank")}
                  //         >
                  //           <img
                  //             src={pdfFileIcon}
                  //             alt="pdf_icon"
                  //             style={{ height: "60px", width: "60px" }}
                  //           />
                  //           <Typography variant="h5" color="#919EAB !important">
                  //             PDF {index + 1}
                  //           </Typography>
                  //         </Stack>
                  //       ))}
                  //     </Stack>
                  //   </Stack>
                  // </Stack>



                  <Stack
                    sx={{
                      backgroundColor: "background.secondary",
                      p: 3,
                      borderRadius: 1.5,
                      minWidth: "50%",
                    }}
                  >
                    <Typography variant="h2">Walkthroughs New</Typography>

                    {/* Tabs */}
                    <Tabs
                      value={newtabValue}
                      onChange={(e, v) => setNewTabValue(v)}
                      textColor="secondary"
                      indicatorColor="secondary"
                    >
                      {teams.map((team, index) => (
                        <Tab key={index} label={team} />
                      ))}
                    </Tabs>

                    <Divider sx={{ my: 2 }} />

                    {/* PDF preview */}
                    <Stack direction="row" gap={2} flexWrap="wrap">
                      {files?.map((item, index) => (
                        <Stack
                          key={index}
                          sx={{
                            width: 140,
                            cursor: item.file_url ? "pointer" : "not-allowed",
                            opacity: item.file_url ? 1 : 0.5
                          }}
                          onClick={() => {
                            if (item.file_url) {
                              window.open(item.file_url, "_blank");
                            }
                          }}
                        >
                          {item.file_url ? (
                            <iframe
                              src={item.file_url}
                              title={`pdf-${index}`}
                              width="140"
                              height="160"
                              style={{
                                border: "1px solid #444",
                                borderRadius: "8px",
                                pointerEvents: "none"
                              }}
                            />
                          ) : (
                            <Stack
                              width="140px"
                              height="160px"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                border: "1px dashed #555",
                                borderRadius: "8px"
                              }}
                            >
                              <Typography variant="caption">
                                No Preview
                              </Typography>
                            </Stack>
                          )}

                          <Typography
                            variant="caption"
                            textAlign="center"
                            mt={0.5}
                          >
                            {item.team_name}
                          </Typography>
                        </Stack>
                      ))}
                    </Stack>
                  </Stack>


                )}
            </Stack>







            {/* {
            Array.isArray(winningWallData) && winningWallData.length > 0 ? (
              <WinningWall
                template="winningWall"
                data={winningWallData}
                header="Achievers"
              />
            ) :
              (<Box textAlign="center" py={4}>
                <Typography variant="h6" color="#919EAB !important" gutterBottom >
                  No Data Available
                </Typography>
                <Typography variant="body2" color="#919EAB !important">
                  There are no achievers to display at the moment.
                </Typography>
              </Box>)
              } */}

          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default ScenarioDetailsVersion2;
